import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const updateRefundableFareFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    !bookWidgetFieldsMasterConfig.refundableFareField?.hide &&
    !bookWidgetFieldsMasterConfig.refundableFareField?.disable
  ) {
    let checked = false;
    if (stringToBoolean(retrieveSearchData?.refundableFlightsOnly)) {
      checked = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      refundableFareField: {
        ...updatedBookWidgetFields.refundableFareField,
        checked,
        disable: false,
        hide: false
      }
    };
  }

  return updatedBookWidgetFields;
};
